import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../services/api';
import PageMeta from '../SEO/PageMeta';
import PublicFooter from '../PublicFooter/PublicFooter';

export default function PublicSubjectPage() {
  const { subject = '' } = useParams();
  const decodedSubject = decodeURIComponent(subject);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    api.get(`/public/subject/${encodeURIComponent(decodedSubject)}`)
      .then(({ data }) => {
        if (active) setCards(data.cards || []);
      })
      .catch(() => {
        if (active) setError('This subject page is unavailable right now.');
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => { active = false; };
  }, [decodedSubject]);

  const title = `${decodedSubject} UPSC Practice Questions & Flashcards | CivilFox`;
  const description = `Study ${decodedSubject} for UPSC with free practice questions and flashcards. Review concise answers, explanations, and related Civil Services preparation resources on CivilFox.`;
  const canonicalPath = `/topic/${encodeURIComponent(decodedSubject)}`;
  const robots = !loading && cards.length ? 'index, follow' : 'noindex, follow';

  return (
    <div className="cb cb-public-card">
      <PageMeta title={title} description={description} path={canonicalPath} robots={robots} />
      <header className="cb-public-header">
        <Link to="/" className="cb-public-brand" aria-label="CivilFox home">CivilFox</Link>
        <Link to="/register" className="cb-public-signup">Start studying free</Link>
      </header>
      <main className="cb-content cb-public-content">
        <nav className="cb-public-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>{decodedSubject}</span>
        </nav>
        <section>
          <h1>{decodedSubject} UPSC practice questions</h1>
          <p>{description}</p>
          {loading && <p role="status">Loading practice questions…</p>}
          {error && <p role="alert">{error}</p>}
          {!loading && !error && !cards.length && (
            <p>No public questions are available for this subject yet.</p>
          )}
          {cards.length > 0 && (
            <ul>
              {cards.map(card => (
                <li key={card._id}>
                  <Link to={`/card/${encodeURIComponent(card.slug || card._id)}`}>
                    {card.question}
                  </Link>
                  {card.examType && <span> · {card.examType}</span>}
                </li>
              ))}
            </ul>
          )}
        </section>
        <nav aria-label="More CivilFox study resources">
          <Link to="/pyq-search">Search previous-year questions</Link>
          {' · '}
          <Link to="/study-upsc-syllabus">Browse the UPSC video syllabus</Link>
          {' · '}
          <Link to="/mock-test">Take a daily Prelims mock test</Link>
        </nav>
      </main>
      <PublicFooter />
    </div>
  );
}
